<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="dates"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateRangeText"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          clearable
          @click:clear="clear_dates"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="dates"
        no-title
        scrollable
        range
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.menu.save(dates); return_value(dates);"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "date-picker-range",
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dates: [],
    // dates: [(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],
    menu: false,
    modal: false,
    menu2: false,
  }),
  computed: {
    dateRangeText: {
      get() {
        return (!!this.dates) ? this.dates.join(' ~ ') : ''
      },
      set(value) {
        this.dates = value;
      }
      // need setter or replace v-model
    },
  },
  methods: {
    clear_dates() {
      this.dates = [];
      this.return_value();
    },
    return_value () {
      this.$emit('return', this.dates)
    }
  },
  mounted() {
    this.$emit('return', this.dates)
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/reusables/datepicker_range.vue